import { MoonFilled, MoonOutlined, ReloadOutlined, SunOutlined } from '@ant-design/icons';
import { Badge, Button, Dropdown } from 'antd';
import { useMemo } from 'react';
import { useThemeMode } from '../Theme';
import { useTheme } from 'antd-style';

const options = [
  {
    key: 'auto',
    label: (
      <>
        <ReloadOutlined /> 跟随系统
      </>
    ),
  },
  {
    key: 'light',
    label: (
      <>
        <SunOutlined /> 浅色模式
      </>
    ),
  },
  {
    key: 'dark',
    label: (
      <>
        <MoonFilled /> 深色模式
      </>
    ),
  },
] as const;

export const ThemeSwitch = () => {
  const [themeMode, setThemeMode] = useThemeMode();
  const { appearance } = useTheme();
  const menu = useMemo(() => {
    return {
      items: options.map(option => {
        const isActive = themeMode === option.key;
        const activeIndicator = isActive ? <Badge status="success" /> : null;
        return {
          key: option.key,
          label: (
            <a
              onClick={e => {
                e.preventDefault();
                setThemeMode(option.key);
              }}>
              {option.label} {activeIndicator}
            </a>
          ),
        };
      }),
    };
  }, [setThemeMode, themeMode]);

  return (
    <Dropdown arrow menu={menu} trigger={['click']} placement="bottomRight">
      <Button
        icon={appearance === 'light' ? <SunOutlined /> : <MoonOutlined />}
        variant="text"
        shape="circle"
        color="cyan"
      />
    </Dropdown>
  );
};
